import { yupResolver } from "@hookform/resolvers/yup";
import { DialogContent, TextField } from "@mui/material";
import { type FC, type ReactNode, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useApiServiceCallback } from "../../../../../server/api/client";
import type { UUID } from "../../../../../utils/uuid";
import { MomentService } from "../../../client";
import { testSendSchema } from "../../../types";
import { SendTestDialogButtons } from "./send-test-dialog-buttons";

export const SendTestToEmail: FC<{
  id: UUID;
  setSaving: (value: boolean) => void;
  setTestDialog: (value: boolean) => void;
  publishing: boolean;
  children?: ReactNode;
}> = ({ id, setSaving, setTestDialog, publishing, children }) => {
  const send = useApiServiceCallback(
    MomentService,
    async ({ apiService }, to: string) => await apiService.sendTest(id, [to], true),
    [id],
  );

  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = useForm<{ to: string }>({
    defaultValues: { to: "" },
    resolver: yupResolver(testSendSchema),
  });

  const onSubmit = useCallback(
    async ({ to }: { to: string }): Promise<void> => {
      const { error } = await send(to);
      setSaving(false);
      if (error) {
        toast.error("Unable to send test Communication, please try again.");
        console.error(error);
      } else {
        toast("Test Communication sent");
        setTestDialog(false);
      }
    },
    [send, setSaving, setTestDialog],
  );

  return (
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <form onSubmit={handleSubmit(onSubmit)}>
      <DialogContent>
        {children}
        <Controller
          name="to"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              label="Email address"
              // eslint-disable-next-line jsx-a11y/no-autofocus
              autoFocus
              fullWidth
              error={Boolean(error)}
              helperText={error?.message || " "}
              sx={{ mt: 2 }}
            />
          )}
        />
      </DialogContent>
      <SendTestDialogButtons
        setSaving={setSaving}
        setTestDialog={setTestDialog}
        publishing={publishing}
        isSubmitting={isSubmitting}
      />
    </form>
  );
};
